// Author Lin
// Date 2022-06-15 16:40:48

class SithMesInventoryManualMaterialType {
constructor({
        id = null,
        materialTypeCode = '',
        materialTypeName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.materialTypeCode = materialTypeCode;
    this.materialTypeName = materialTypeName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryManualMaterialType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialTypeCode',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.grid.materialTypeCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialTypeName',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.grid.materialTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialTypeCodeFilter : '',
    materialTypeNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialTypeCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.filter.materialTypeCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialTypeNameFilter',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.filter.materialTypeName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'materialTypeCode',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.entity.materialTypeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialTypeName',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.entity.materialTypeName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualMaterialType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryManualMaterialType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
